var _defs, _circle, _circle2, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSZ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#29317d;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:#fdb71d;}.cls-6{fill:#fff;}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1434.2,
    y1: 492.22,
    x2: -1433.81,
    y2: 492.22,
    gradientTransform: "matrix(20.41, 0, 0, -26.72, 29289.06, 13172.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7671b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#be9fcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#d7b0d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#726ab0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#4151a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#6b65ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#d7b0d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#6dcde5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1211.17,
    y1: 481.8,
    x2: -1210.78,
    y2: 481.8,
    gradientTransform: "matrix(5.09, 0, 0, -13.3, 6181.12, 6431.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7671b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#65bae8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#6dcde5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#d7b0d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#4151a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2.17,
    y1: 10.77,
    x2: 20.57,
    y2: 6.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#686cb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#35a2b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#35a3b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#3aada1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3db595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3fb98e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#3fba8c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.73,
    y1: 17.72,
    x2: 28.93,
    y2: 9.33,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 4.85,
    y1: 13.96,
    x2: 20.52,
    y2: 7.29,
    xlinkHref: "#linear-gradient-3"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.62,
    cy: 12.36,
    r: 8.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    className: "cls-2",
    cx: 21.17,
    cy: 18.6,
    r: 8.83
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-3",
    d: "M23.4,20.05l2.13,3.77h-2l-3-5.27h1.55a1.65,1.65,0,0,0,1.21-.51,1.68,1.68,0,0,0,.52-1.25,1.61,1.61,0,0,0-.52-1.22,1.65,1.65,0,0,0-1.21-.51c-.95,0-2.09.06-2.75.08-.16,0-.44,0-.79,0l-1-1.83,4.56,0a3.47,3.47,0,0,1,3.46,3.49,3.55,3.55,0,0,1-2.13,3.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-4",
    d: "M19.48,22.17v1.64h-2c0-1.74,0-3.48,0-5.23h.11l.13.43a25.21,25.21,0,0,0,1.76,3.16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-5",
    d: "M19.46,15.14h0v0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-6",
    d: "M23.51,20.08l2.13,3.73h-2l-3-5.22h1.55a1.76,1.76,0,0,0,1.73-1.74,1.59,1.59,0,0,0-.52-1.21,1.65,1.65,0,0,0-1.21-.51l-3.59,0-1-1.75,4.56,0a3.48,3.48,0,0,1,3.47,3.47,3.34,3.34,0,0,1-.62,2,3.38,3.38,0,0,1-1.52,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-6",
    d: "M19.59,22.17v1.64h-2c0-1.74,0-3.49,0-5.23l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-6",
    d: "M19.57,15.14h0v0Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-5",
    d: "M19.36,15.13h0v0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M7.83,10.33H4.46a.87.87,0,0,1-.26-.08A1.15,1.15,0,0,1,4.32,10c.44-.49.87-1,1.33-1.46A.55.55,0,0,1,6,8.38c2.25,0,4.51,0,6.76,0a.3.3,0,0,1,.23.09s0,.16-.08.22c-.44.49-.88,1-1.34,1.47a.58.58,0,0,1-.39.17c-1.13,0-2.25,0-3.37,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M9.38,14.38h3.37a.9.9,0,0,1,.28.08,1.15,1.15,0,0,1-.12.25c-.45.49-.89,1-1.35,1.47a.53.53,0,0,1-.33.15c-2.27,0-4.53,0-6.79,0a.81.81,0,0,1-.22-.07.81.81,0,0,1,.1-.21c.43-.49.87-1,1.32-1.46A.58.58,0,0,1,6,14.4H9.38Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M9.38,13.33H6.11a.64.64,0,0,1-.53-.23c-.41-.47-.84-.93-1.25-1.39a1.19,1.19,0,0,1-.13-.25,1.34,1.34,0,0,1,.27-.07l6.67,0a.6.6,0,0,1,.5.22c.39.45.81.89,1.2,1.34a1.69,1.69,0,0,1,.19.32,1.47,1.47,0,0,1-.35.08Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSZ);
export default __webpack_public_path__ + "static/media/S-Z.917931b17c7f8d458775b5f3f5f07c7a.svg";
export { ForwardRef as ReactComponent };